import { useQuery } from "react-query";
import { getForReviewInvoices } from "../../../../../actions/CarrierAgreementMgmt/VendorInvoice";

export const useGetForReviewInvoices = () => {
  return useQuery("GetForReviewInvoices", getForReviewInvoices, {
    refetchOnWindowFocus: false,
  });
};
